/* RESPONSIBLE TEAM: team-automation-foundations */
import Model, { attr } from '@ember-data/model';

export default class PreviewSettings extends Model {
  @attr('string') declare previewAddress: string;
}
